/**
 * Notion URL of the user's habit tracker: the page holding the connected
 * database when its id is known, else the database itself; null when neither
 * id is known. Notion accepts ids without dashes.
 */
export function notionTrackerUrl(
  trackerPageId?: string | null,
  databaseId?: string | null,
): string | null {
  const id = trackerPageId || databaseId;
  return id ? 'https://www.notion.so/' + id.replace(/-/g, '') : null;
}
